var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCartelera(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m371.613 57.806h16.516v49.548h-16.516z",
    fill: "#c8c5c9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m388.129 66.065h-16.516c-4.561 0-8.258-3.697-8.258-8.258v-16.517c0-9.122 7.395-16.516 16.516-16.516 9.122 0 16.516 7.395 16.516 16.516v16.516c0 4.561-3.697 8.259-8.258 8.259z",
    fill: "#9b959d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m123.871 57.806h16.516v49.548h-16.516z",
    fill: "#c8c5c9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m140.387 66.065h-16.516c-4.561 0-8.258-3.697-8.258-8.258v-16.517c0-9.122 7.395-16.516 16.516-16.516 9.122 0 16.516 7.395 16.516 16.516v16.516c0 4.561-3.697 8.259-8.258 8.259z",
    fill: "#9b959d"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#c8c5c9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m247.742 57.806h16.516v49.548h-16.516z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m57.806 338.581h16.516v41.29h-16.516z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m437.677 338.581h16.516v41.29h-16.516z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m272.516 487.226h-24.774l-8.075-91.559 41.108 8.978v74.323c-.001 4.561-3.698 8.258-8.259 8.258z",
    fill: "#dad8db"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m231.226 330.323v148.645c0 4.561 3.697 8.258 8.258 8.258h8.258v-66.065c0-9.122 7.395-16.516 16.516-16.516h16.516v-74.323h-49.548z",
    fill: "#c8c5c9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m487.226 99.097h-454.194c-4.561 0-8.258 3.697-8.258 8.258v222.968c0 4.561 3.697 8.258 8.258 8.258h454.194c4.561 0 8.258-3.697 8.258-8.258v-222.968c0-4.561-3.697-8.258-8.258-8.258z",
    fill: "#ff8086"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m264.258 66.065h-16.516c-4.561 0-8.258-3.697-8.258-8.258v-16.517c0-9.122 7.395-16.516 16.516-16.516 9.122 0 16.516 7.395 16.516 16.516v16.516c0 4.561-3.697 8.259-8.258 8.259z",
    fill: "#9b959d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m200.782 169.504c-3.274-7.653-10.774-12.601-19.105-12.601s-15.831 4.948-19.097 12.593l-46.298 108.024c-1.798 4.194.145 9.048 4.339 10.843 4.153 1.794 9.04-.141 10.839-4.335l8.474-19.77h83.488l8.473 19.77c1.339 3.129 4.387 5.008 7.589 5.008 1.089 0 2.194-.218 3.25-.673 4.194-1.794 6.137-6.649 4.339-10.843zm-53.769 78.238 30.753-71.746c1.339-3.129 6.476-3.137 7.831.008l30.746 71.738z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m322.065 156.903h-41.29c-4.565 0-8.258 3.698-8.258 8.258v115.613c0 4.56 3.694 8.258 8.258 8.258h41.29c36.427 0 66.065-29.637 66.065-66.065s-29.638-66.064-66.065-66.064zm0 115.613h-33.032v-99.097h33.032c27.323 0 49.548 22.226 49.548 49.548s-22.226 49.549-49.548 49.549z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m82.581 330.323c-27.365 0-49.548-22.184-49.548-49.548v-181.678h-8.113c-4.642 0-8.404 3.763-8.404 8.404v230.933c0 4.642 3.763 8.404 8.404 8.404h462.16c4.642 0 8.404-3.763 8.404-8.404v-8.112h-412.903z",
    fill: "#e5646e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m503.742 388.129h-495.484c-4.565 0-8.258-3.698-8.258-8.258s3.694-8.258 8.258-8.258h495.484c4.565 0 8.258 3.698 8.258 8.258s-3.694 8.258-8.258 8.258z",
    fill: "#dad8db"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartelera);
export default __webpack_public_path__ + "static/media/cartelera.111638dc1cde9efeaaa14185e3f74539.svg";
export { ForwardRef as ReactComponent };